import React from "react";
import { Col, Divider, Form, Modal, Row } from "antd";
import { useSupporterAdd } from "hook/supporters/useSupporter";
import { useSelector } from "react-redux";
import { defaultSupporterOpenAddSelector } from "store/user/(default)/supporter/default_supporter.selector";
import SupporterSearch from "./component/supporter_search";
import SupporterInput from "./component/supporter_input";
import SupporterPermissions from "./component/supporter_permissions";
import SupporterNote from "./component/supporter_note";
import SupporterAction from "./component/supporter_action";
import SupporterScan from "./component/supporter_scan";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DialogAddSupporter = () => {
  // -------------------------- VAR -----------------------------
  const [form] = Form?.useForm();
  const { handleCloseAdd } = useSupporterAdd();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const open = useSelector(defaultSupporterOpenAddSelector);

  // -------------------------- FUNCTION ------------------------
  const handleClose = () => {
    handleCloseAdd(form);
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN ----------------------------
  return (
    <Modal
      open={open}
      footer={null}
      centered
      title="Thêm nhân viên mới"
      onCancel={handleClose}
      className="dialog-supporter-add"
      width={650}
    >
      <Divider style={{ margin: 0 }} />
      <Form form={form} layout="vertical" id="dialog-supporter-add">
        <Row gutter={[0, 20]} style={{ padding: 20 }}>
          <Col xl={24} lg={24} md={24} xs={24}>
            <SupporterSearch />
            <SupporterScan />
            <SupporterInput />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <SupporterPermissions />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <SupporterNote />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <SupporterAction />
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
export default DialogAddSupporter;
